import React, { useEffect, useState } from "react";
import AddButton from "../../../../components/admin/usable/AddButton";
import AddPlusButton from "../../../../components/admin/usable/actions/AddPlusButton";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import MultiHotelSection from "../../../../components/admin/usable/MultiHotelSection";
import toast from "react-hot-toast";
import {
  addFeaturedHotels,
  getFeaturedHotels,
  updatedFeaturedHotels,
} from "../../../../api/admin/homePageApi";

const FeaturedHotels = () => {
  const [FormData, setFormData] = useState([
    { id: null, sectionTitle: "", selectedHotels: [] },
  ]);
  useEffect(() => {
    getFeaturedHotels(setFormData);
  }, []);
  const handleAdd = () => {
    setFormData((prev) => {
      return [
        ...prev,
        {
          sectionTitle: "",
          selectedHotels: [],
        },
      ];
    });
  };
  const handleRemove = (index) => {
    setFormData((prev) => {
      return prev.filter((item, i) => i !== index);
    });
  };
  const handleAddHotels = () => {
    addFeaturedHotels(FormData, setFormData);
  };
  const handleUpdateHotels = () => {
    updatedFeaturedHotels(FormData, setFormData);
  };

  return (
    <div className="w-full h-auto border p-3 bg-white rounded-lg space-y-5">
      <div className="flex justify-start items-center gap-2">
        <p className="text-m font-medium">Featured Hotel Sections</p>
        <AddPlusButton onClick={handleAdd} />
      </div>

      <div>
        {FormData.map((item, index) => {
          return (
            <div key={index} className="grid grid-col-1 lg:grid-cols-2 gap-10">
              <div>
                <label className="text-xs">Section Title</label>
                <input
                  type="text"
                  placeholder="Section Title"
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                  value={item.sectionTitle}
                  onChange={(e) =>
                    setFormData((prev) => {
                      const newData = [...prev];
                      newData[index].sectionTitle = e.target.value;
                      return newData;
                    })
                  }
                />
              </div>
              <div className="w-full">
                <div className="flex justify-start items-center gap-3">
                  <div className="w-full">
                    <label className="text-xs">Section Hotels</label>
                    <MultiHotelSection
                      setFormData={setFormData}
                      sectionIndex={index}
                    />
                  </div>
                  {FormData.length > 1 && (
                    <div className="mt-6">
                      <DeleteButton onClick={() => handleRemove(index)} />
                    </div>
                  )}
                </div>
                {FormData[index].selectedHotels.length > 0 && (
                  <div className="pt-3 flex justify-start items-center gap-1 flex-wrap">
                    {FormData[index].selectedHotels.map((hotel, hIndex) => (
                      <div key={hIndex} className="">
                        <div className="bg-gray-100 rounded-md px-2 py-1">
                          <div className="flex items-center gap-2">
                            <p className="text-xs">{hotel.hotelName}</p>{" "}
                            <DeleteButton
                              onClick={() => {
                                setFormData((prev) => {
                                  const newData = [...prev];
                                  newData[index].selectedHotels = newData[
                                    index
                                  ].selectedHotels.filter(
                                    (_, i) => i !== hIndex,
                                  );
                                  return newData;
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-end items-end gap-2">
        <AddButton onClick={handleAddHotels} text="Add Now" size="md" />
        {FormData.length > 0 && (
          <AddButton onClick={handleUpdateHotels} text="Update Now" size="md" />
        )}
      </div>
    </div>
  );
};

export default FeaturedHotels;
